import { FunctionField } from 'react-admin';
import { styled } from '@mui/material/styles';

export const CapitalizedFunctionField = styled(FunctionField)({
  textTransform: 'capitalize',
});

export const ActionsContainer = styled('div')({
  display: 'flex',
  gap: '10px',
  marginBottom: '10px',
});
